import { h } from "preact";
import Required from "./Required";
import Description from "./Description";
import { css } from "emotion";
import { max } from "../../utils/CssUtils";

const styles = {
  container: css`
    position: relative;
  `,
  radioChecked: css`
    position: absolute;
    top: 10px;
    left: 5px;
    width: 10px;
    height: 10px;
    background-color: #6621c0;
    border-radius: 50%;
  `
};

const textWrapper = css({
  [max(768)]: {
    fontSize: 14
  }
});

const RadioField = ({
  input,
  label,
  description,
  required,
  inline,
  options,
  meta: { touched, error, warning }
}) => {
  const radio = css({
    position: "absolute",
    top: 5,
    width: 20,
    height: 20,
    left: 0,
    bottom: 0,
    zIndex: 1,
    cursor: "pointer",
    opacity: 0,
    "&:focus": {
      "+ span": {
        borderColor: "orange !important"
      }
    }
  });
  const style = inline ? { display: "inline-block", marginRight: 40 } : null;
  return (
    <fieldset class={touched && error ? "form-group has-error" : "form-group"}>
      <legend for={input.name} className={textWrapper}>
        <i class="form-icon" /> {label}
        <Required required={required} />
        <br />
        <Description description={description} />
        {options.map(option => {
          const checked = input.value === option.value ? true : false;
          const radioInner = css({
            position: "relative",
            top: 5,
            left: 0,
            display: "block",
            width: 20,
            height: 20,
            marginRight: 10,
            backgroundColor: "white",
            borderStyle: "solid",
            borderWidth: 2,
            borderRadius: 100,
            transition: "all 0.3s",
            borderColor: checked ? "#6621c0" : "#67717e",
            display: inline ? "inline-block" : null
          });
          return (
            <div key={option.label} className={styles.container} style={style}>
              <input
                type="radio"
                {...input}
                checked={checked}
                onChange={e => {
                  input.onChange(e);
                }}
                name={label}
                id={option.label}
                value={option.value}
                className={radio}
                aria-describedby={`${input.name}Error`}
              />
              <span id="inner" className={radioInner} />
              {checked ? (
                <span className={styles.radioChecked} id="checked" />
              ) : null}
              <label for={option.label}>{option.label}</label>
            </div>
          );
        })}
      </legend>
      {touched && error && (
        <p class="form-input-hint" id={`${input.name}Error`}>
          {error}
        </p>
      )}
    </fieldset>
  );
};

export default RadioField;



// WEBPACK FOOTER //
// ./components/fields/RadioField.js